export default "https://assets.egbcdn.net/assets/packs/_/images/app/ios/ios-en-2-f5c0ec2def2167ba9abb55efe894fa19.png";